import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';
import store from "Store/index"
import { mixins } from 'vue-class-component';
import UserMixin from 'Mixins/UserMixin';
import BaseComponent from 'Components/Base/ABaseComponent';
import OrderingListUserMixin from 'Mixins/OrderingListUserMixin';


@Component({
})
export default class AOrderingListConditionComponent extends mixins(BaseComponent,OrderingListUserMixin){

  
    async created(){
        
    }
}

Vue.component('ordering-list-condition', AOrderingListConditionComponent);